import { Chip } from '@mui/material';
import toast from 'react-hot-toast';
import { httpRequest } from 'src/services/httpRequest';

export const columns = [
  'Service Name',
  'Department Name',
  'Subscription Fee (Yearly)',
  'Active Subscribers',
  'Status ',
  'Actions (Edit/Delete)'
];

interface Field {
  permitName: string;
  departmentName: string;
  subscriptionFee: number;
  validityPeriod: number;
  status: string;
  action: string;
}

interface DepartmentFields {
  DepartmentID: number;
  DepartmentName: string;
}

interface SubscriptionFeeFields {
  Monthly: number;
  Yearly: number;
}

interface PermitData {
  PermitName: string;
  Departments: DepartmentFields;
  SubscriptionFee: SubscriptionFeeFields;
  ActiveSubscribers: number;
  Status: string;
}

export const getData = async (
  url: string,
  setState: (data: Field[]) => void,
  action: (data: any) => void
) => {
  try {
    const response = await httpRequest('GET', url);
    if (response?.status === 'success') {
      const data = await response?.data?.Data;
      const Permits = data?.map((item: PermitData) => {
        return {
          permitName: item.PermitName,
          departmentName: item.Departments.DepartmentName,
          subscriptionFee: `$${item.SubscriptionFee.Yearly}`,
          activeSubscribers: item.ActiveSubscribers,
          status: (
            <Chip
              label={item.Status}
              color={item.Status === 'Active' ? 'success' : 'error'}
              variant="outlined"
              sx={{ fontWeight: 'bold' }}
            />
          ),
          action: action(item)
        };
      });
      setState(Permits);
    } else if (response.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
    }
  } catch (error) {
    toast.error('An error occurred while fetching permits');
    console.error('Error:', error);
  }
};
